import { Form, Modal } from "react-bootstrap";
import React from "react";
import { ReactComponent as Blackclose } from "../../assets/images/black-close.svg";
import AppConfig from "../../config/app.config";
import UserService from "../../services/user/user.service";
import { NotificationManager } from "react-notifications";
import { Backdrop, CircularProgress } from "@mui/material";

class CommentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commentsList: this.props.commentsList,
      employeeId: this.props.employeeId,
      employeeName: this.props.employeeName,
      projectId: this.props.projectId,
      comment: "",
      isLoading: 0,
    };
  }

  componentDidMount() {}

  handleComment = (event) => {
    this.setState({ comment: event.target.value });
  };

  deleteComment = async (projectCommentId) => {
    const tempCommentList = this.state.commentsList;

    let commentDataList = [];
    for (var i = 0; i < this.state.commentsList.length; i++) {
      if (projectCommentId !== this.state.commentsList[i].projectCommentId) {
        commentDataList.push(this.state.commentsList[i]);
      }
    }
    this.setState({
      commentsList: commentDataList,
      comment: "",
      isLoading: 1,
    });

    try {
      const res = await UserService.deleteComment(projectCommentId);
      if (res.error != null) {
        if (res.error?.response?.data?.message != null) {
          NotificationManager.error("", res.error.response.data.message, 3000);
          this.setState({
            isLoading: 0,
            commentsList: tempCommentList,
            comment: "",
          });
        } else {
          NotificationManager.error("", "Could not Delete Comment.", 3000);
          this.setState({
            isLoading: 0,
            commentsList: tempCommentList,
            comment: "",
          });
        }
      } else {
        if (res["status"]) {
          NotificationManager.success("", "Comment Deleted Successfully.", 3000);
          this.setState({ isLoading: 0 });
          this.props.updateComment(commentDataList);
        } else {
          NotificationManager.error("", "Could not Delete Comment.", 3000);
          this.setState({
            isLoading: 0,
            commentsList: tempCommentList,
            comment: "",
          });
        }
      }
    } catch (err) {
      NotificationManager.error("", "Could not Delete Comment.", 3000);
      this.setState({
        isLoading: 0,
        commentsList: tempCommentList,
        comment: "",
      });
    }
  };

  saveComment = async () => {
    if (this.state.comment === "") {
      NotificationManager.warning("Please Enter Comment.", "", 2000);
    } else if (this.state.comment.trim().length === 0) {
      NotificationManager.warning("Please Enter Comment.", "", 2000);
    } else {
      try {
        this.setState({ isLoading: 1 });
        const res = await UserService.saveComment({
          subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
          verticalId: AppConfig.API.VERTICAL_ID,
          appId: AppConfig.API.APP_ID,
          projectId: this.state.projectId,
          loginEmployeeId: this.state.employeeId,
          comment: this.state.comment,
        });
        if (res.error != null) {
          if (res.error?.response?.data?.message != null) {
            NotificationManager.error(
              "",
              res.error.response.data.message,
              3000
            );
            this.setState({ isLoading: 0 });
          } else {
            NotificationManager.error("", "Could not add Comment.", 3000);
            this.setState({ isLoading: 0 });
          }
        } else {
          if (res["status"]) {
            NotificationManager.success(
              "",
              "Comment added Successfully.",
              3000
            );
            this.setState({ isLoading: 0 });
            let data = res["data"];
            data.loginEmployeeName = this.state.employeeName;
            let commentDataList = [];
            commentDataList.push(data);
            for (var i = 0; i < this.state.commentsList.length; i++) {
              commentDataList.push(this.state.commentsList[i]);
            }
            this.setState({ commentsList: commentDataList, comment: "" });
            this.props.updateComment(commentDataList);
          } else {
            this.setState({ isLoading: 0 });
            NotificationManager.error("", "Could not add Comment.", 3000);
          }
        }
      } catch (err) {
        this.setState({ isLoading: 0 });
        NotificationManager.error("", "Could not add Comment.", 3000);
      }
    }
  };

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.hideModal}
        backdrop="static"
        keyboard={false}
        centered
        id="ShareModal"
      >
        {this.state.isLoading === 1 && (
          <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <div className="modal-close">
          <Blackclose className="closeicon" onClick={this.props.hideModal} />
        </div>
        <div className="comment-modal">
          <div className="comment-fields">
            <img
              //src={require("../../assets/images/user-icon.png")}
              src={
                AppConfig.API.USER_PROFILE +
                this.state.employeeId +
                "&random=" +
                new Date()
              }
              alt="Profile"
              className="user-icon"
            />
            <Form.Group className="comment-group">
              <Form.Control
                as="textarea"
                placeholder="Your message"
                className="comment-field"
                rows={3}
                value={this.state.comment}
                onChange={this.handleComment}
                autoComplete="off"
                required
              />
            </Form.Group>
          </div>
          <div className="commentbtn-right">
            <button
              type="button"
              className="comment-btn"
              onClick={() => {
                this.saveComment();
              }}
            >
              Comment
            </button>
          </div>
          {this.state.commentsList != null &&
            this.state.commentsList.length > 0 &&
            this.state.commentsList.map((data, index) => {
              return (
                <div className="comment-details" key={index}>
                  <div className="comment-userinfo">
                    <img
                      //   src={require("../../assets/images/user-icon.png")}
                      src={AppConfig.API.USER_PROFILE + data.loginEmployeeId}
                      alt="Profile"
                      className="user-icon"
                    />
                    <div className="comment-name">
                      <h4>
                        {" "}
                        {data.loginEmployeeName != null
                          ? data.loginEmployeeName
                          : ""}
                      </h4>
                      <h5> {data.date != null ? data.date : ""}</h5>
                    </div>
                    {data.loginEmployeeId === this.state.employeeId ? (
                      <div className="delete-comment">
                        <img
                          src={require("../../assets/images/delete.png")}
                          alt="delete-comment"
                          className="delete-comment-img"
                          onClick={() => {
                            this.deleteComment(data.projectCommentId);
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <p>{data.comment != null ? data.comment : ""}</p>
                </div>
              );
            })}
        </div>
      </Modal>
    );
  }
}

export default CommentModal;
